import { Row, ColumnHeading } from '@ui/kit';
import { headerCls, dateHeadingCls } from './header.simplified.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SimplifiedHeader() {
  return /*#__PURE__*/jsxs(Row, {
    as: "header",
    sizingCls: undefined,
    className: headerCls,
    children: [/*#__PURE__*/jsx(ColumnHeading, {
      label: "Titel"
    }), /*#__PURE__*/jsx(ColumnHeading, {
      label: "Fag"
    }), /*#__PURE__*/jsx(ColumnHeading, {
      label: "Niveau"
    }), /*#__PURE__*/jsx(ColumnHeading, {
      className: dateHeadingCls,
      children: "Sidst \xE6ndret"
    })]
  });
}

export { SimplifiedHeader };
//# sourceMappingURL=header.simplified.js.map
